import type { RouteConfig } from '@asteasolutions/zod-to-openapi';
import { axios } from '../axios';
import { registerRoute, urlBuilder } from '../utils';
import { z } from '../zod';

export const CHECK_BASE_INTEGRITY = '/integrity/base/bse0/link-check';

// Define the issue types enum
export enum IntegrityIssueType {
  ForeignTableNotFound = 'ForeignTableNotFound',
  ForeignKeyNotFound = 'ForeignKeyNotFound',
  SelfKeyNotFound = 'SelfKeyNotFound',
  SymmetricFieldNotFound = 'SymmetricFieldNotFound',
  MissingRecordReference = 'MissingRecordReference',
  InvalidLinkReference = 'InvalidLinkReference',
  ForeignKeyHostTableNotFound = 'ForeignKeyHostTableNotFound',
}

// Define the schema for a single issue
export const integrityIssueSchema = z.object({
  type: z.nativeEnum(IntegrityIssueType),
  message: z.string(),
});

// Define the schema for a link field check item
export const linkFieldCheckItemSchema = z.object({
  fieldId: z.string(),
  fieldName: z.string(),
  tableId: z.string(),
  tableName: z.string(),
  issues: z.array(integrityIssueSchema),
});

export type IIntegrityIssue = z.infer<typeof integrityIssueSchema>;

// Define the response schema
export const integrityCheckVoSchema = z.object({
  hasIssues: z.boolean(),
  linkFieldIssues: z.array(linkFieldCheckItemSchema),
});

export type IIntegrityCheckVo = z.infer<typeof integrityCheckVoSchema>;

export const IntegrityCheckRoute: RouteConfig = registerRoute({
  method: 'get',
  path: CHECK_BASE_INTEGRITY,
  description: 'Check integrity of link fields in a base',
  request: {},
  responses: {
    200: {
      description: 'Returns integrity check results for the base',
      content: {
        'application/json': {
          schema: integrityCheckVoSchema,
        },
      },
    },
  },
  tags: ['integrity'],
});

export const checkBaseIntegrity = async () => {
  return axios.get<IIntegrityCheckVo>(urlBuilder(CHECK_BASE_INTEGRITY));
};
